import { render, staticRenderFns } from "./storeroom.vue?vue&type=template&id=2861760d&scoped=true&"
import script from "./storeroom.vue?vue&type=script&lang=js&"
export * from "./storeroom.vue?vue&type=script&lang=js&"
import style0 from "./storeroom.vue?vue&type=style&index=0&id=2861760d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2861760d",
  null
  
)

export default component.exports